import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { HeadingLabel } from '../../HeadingLabel'
import { MostBookedByLabel } from '../ReviewDetails/Overview/MostBookedByLabel'
import { ReviewDetails } from '../ReviewDetails/ReviewDetails'
import { LegalDisclamer } from './LegalDisclamer'
import { Rating } from './Rating'
import { Reviews } from './Reviews'
import styles from './Teaser.module.css'

export function Teaser() {
  const { reviewsAmount, isFetched } = useUserReviewsInitialData()
  const shouldShowRatings = useCMSPageField('userReviews.shouldShowRatings')

  const intl = useIntl()

  if (isFetched && !reviewsAmount) {
    return (
      <div className={styles.section}>
        <Typography variant="display-f-regular">{intl.formatMessage({ id: 'reviews_teaser_title' })}</Typography>
        <Banner color="informative" size="M" text={intl.formatMessage({ id: 'reviews_no_reviews_teaser' })} />
      </div>
    )
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <HeadingLabel text={intl.formatMessage({ id: 'reviews_teaser_title' })} />
        <LegalDisclamer />
      </div>
      <div className={styles.sectionIntroduction}>
        <div className={styles.ratingWrapper}>
          {shouldShowRatings
          && (
            <ReviewDetails>
              <button>
                <Rating />
              </button>
            </ReviewDetails>
          )}
          <MostBookedByLabel />
        </div>
        <Reviews />
        <ReviewDetails>
          <Button variant="outlinedPrimary" className={styles.styledButton}>{intl.formatMessage({ id: 'reviews_teaser_see_all_reviews' }, { amount: reviewsAmount })}</Button>
        </ReviewDetails>
      </div>
    </div>
  )
}
